import { useQuery } from '@tanstack/react-query';
import { jobServices } from '../services/job.service';

export const useApplications = (filters) => {
  return useQuery({
    queryKey: ['applications', filters],
    queryFn: () => jobServices.getAllApplications(filters),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    keepPreviousData: true,
  });
};

export const useJobApplicants = ({ jobId, ...filters }) => {
  return useQuery({
    queryKey: ['job-applicants', jobId, filters],
    queryFn: () => jobServices.getJobApplicants({ jobId, ...filters }),
    enabled: !!jobId,
    staleTime: 5 * 60 * 1000,
    keepPreviousData: true,
  });
};
